import { render, staticRenderFns } from "./FloatingButtonSave.vue?vue&type=template&id=3c75d2e6"
import script from "./FloatingButtonSave.vue?vue&type=script&lang=js"
export * from "./FloatingButtonSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports